import { animated, useSpring, easings } from '@react-spring/web'

const animations = {
  fadeIn: {
    from: { opacity: 0 /*, transform: 'translate3d(0px,0px,0)'*/ },
    to: { opacity: 1 /*, transform: 'translate3d(0px,0px,0)' */ },
    //config: { tension: 500, friction: 50, clamp: true },
    config: { easing: easings.easeInExpo },
  },
  hover: {
    from: { scale: 1.1 },
    to: { scale: 1 },
    //config: { tension: 500, friction: 50, clamp: true },
    config: { easing: easings.easeInExpo },
  },
}
export const useFadeIn = () => {
  const spring = useSpring(animations.fadeIn)
  return {
    animated,
    spring,
  }
}

export const useScaleUp = () => {
  const [props, api] = useSpring(() => animations.hover, [])

  const spring = props

  const hover = () => {
    api.start(animations.hover.from)
  }
  const out = () => {
    api.start(animations.hover.to)
  }

  return {
    animated,
    spring,
    hover,
    out,
  }
}

/*


20 x 80
45 x 80
30 x 60
30 x 80


40 x 10
40 x 20
40 x 40
40 x 60
40 x 80
40 x 100
40 x 120
40 x 140
40 x 180
40 x 200
40 x 220

60 x 10
60 x 20
60 x 40
60 x 60
60 x 80
60 x 100
60 x 120
60 x 140
60 x 180
60 x 200
60 x 220
80 x 10
80 x 20
80 x 40
*/
